import { BaseApi } from "../BaseApi";

const consultarCargaPantallasUrl = "/api/v1/websalud/primeraars/configuracion/cargapantallas";

const consultarCargaPantallas = () => {
  return BaseApi.get(consultarCargaPantallasUrl).then((response) => response.data);
};

const exportedObject = {
  consultarCargaPantallas,
};

export default exportedObject;

